// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { searchLocationApi } from '../api';
import NewFlightForm from '../../new-flight/components/NewFlightForm/NewFlightForm';
import Modal from '../../../elements/Modal/Modal';
import Loading from '../../../elements/Loading/Loading';

import style from './EditFlight.scss';

import type { User, Flight } from '../../../entities';
import type { LocalValuesState } from '../../local-values/duck';

type Props = {
  +authenticated: boolean;
  +user: User;
  +locale: string;
  +localValues: LocalValuesState;
  +editFlight: (flightDate: string, departureCountry: string, departureAdmin1: number,
                departureAdmin2: number, arrivalCountry: string, arrivalAdmin1: number,
                arrivalAdmin2: number, id: string) => void;
  +getFlight: () => void;
  +isPutting?: boolean;
  +isFetching?: boolean;
  +successUpdate?: boolean;
  +flight?: Flight;
  +resetState?: () => void;
  +id: string;
  +handleCloseModal: () => void;
  +isOpen: boolean;
};

export default class EditFlight extends Component<Props, void> {

  componentWillUnmount() {
    const { resetState } = this.props;
    if (resetState) resetState();
  }

  render() {
    const {
      locale, editFlight, getFlight, isPutting, isFetching, flight, id, authenticated, user, localValues,
      handleCloseModal, isOpen, successUpdate,
    } = this.props;
    return (
      <Modal handleClose={() => !isPutting && handleCloseModal()}
             open={isOpen}
             width={416}
             height={650}>
        {(isPutting || successUpdate) ?
          <Loading type="circle"
                   className={style.loading}/> :
          <section className={style.formWrap}>
            <NewFlightForm locale={locale}
                           localValues={localValues}
                           searchLocation={searchLocationApi}
                           getFlight={getFlight}
                           isFetching={isFetching}
                           editFlight={editFlight}
                           isPosting={isPutting}
                           flight={flight}
                           authenticated={authenticated}
                           user={user}
                           id={id}
                           mode="edit"/>
          </section>}
      </Modal>);
  }
}

EditFlight.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  locale: PropTypes.string.isRequired,
  localValues: PropTypes.object,
  editFlight: PropTypes.func.isRequired,
  getFlight: PropTypes.func.isRequired,
  isPutting: PropTypes.bool,
  isFetching: PropTypes.bool,
  successUpdate: PropTypes.bool,
  flight: PropTypes.object,
  resetState: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/edit-flight/components/EditFlight.jsx